export default __webpack_public_path__ + "static/loyalty-380630eda57614682dffc7baa46421df.png";